import React from 'react';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import OpenCsQnaQuestion from '../../../../../containers/cs/qna/common/OpenCsQnaQuestion';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenUserDetail from '../../../../../components/link/OpenUserDetail';
import Anchor from '../../../../../components/link/Anchor';
import { openNewWindow, setColumnWidth, setDetailPageUrl } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { CS_QNA_STATUS_TEXT } from '../../../../../constants/service/app/csQnaConstants';
import { CS_INQUIRY_RESPONSE_STATUS_TEXT } from '../../../../../constants/service/app/csInquiryConstants';
import { CS_QNA_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { ORDER_ITEM_STATUS_TEXT } from '../../../../../constants/service/app/orderConstants';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';

/**
 *  상품 문의 리스트 컬럼
 */
const columns = (data) => {
  const { list } = data;
  return [
    {
      accessor: 'isResponse',
      Header: '답변 처리',
      fixed: 'left',
      width: 120,
      Cell: (row) => (
        <Anchor
          text={CS_INQUIRY_RESPONSE_STATUS_TEXT[row.value]}
          isUnderLine
          color="primary"
          href={setDetailPageUrl(CS_QNA_DETAIL_URL_PATH, row.original.id)}
          target="_blank"
        />
      ),
    },
    {
      accessor: 'orderItemId',
      Header: '주문여부',
      fixed: 'left',
      width: 120,
      Cell: (row) => <OpenOrderItemDetail text={row.value} orderItemId={row.value} />,
    },
    {
      accessor: 'orderItemStatus',
      Header: '주문상태',
      fixed: 'left',
      width: 120,
      Cell: (row) => ORDER_ITEM_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'id',
      Header: '상품 문의 ID',
      fixed: 'left',
      width: 120,
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          text={row.value}
          onClick={() => openNewWindow(setDetailPageUrl(CS_QNA_DETAIL_URL_PATH, row.value))}
        />
      ),
    },
    {
      accessor: 'status',
      Header: '상태',
      fixed: 'left',
      width: 140,
      Cell: (row) => CS_QNA_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'productId',
      Header: '상품번호(AMONDZ)',
      fixed: 'left',
      width: 150,
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
    },
    {
      accessor: 'productName',
      Header: '상품명',
      className: 'align-left',
      resizable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'productName'),
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
    },
    {
      accessor: 'storeName',
      Header: '상점명',
      resizable: true,
      width: setColumnWidth(list, 'storeName'),
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      width: 70,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
    },
    {
      accessor: 'userAccount',
      Header: '문의자 ID',
      resizable: true,
      width: setColumnWidth(list, 'userAccount'),
      Cell: (row) => <OpenUserDetail text={row.value} userId={row.original.userId} />,
    },
    {
      accessor: 'userName',
      Header: '문의자명',
      width: setColumnWidth(list, 'userName'),
    },
    {
      accessor: 'question',
      Header: '문의내용',
      className: 'align-left',
      resizable: true,
      width: 400,
      Cell: (row) => <OpenCsQnaQuestion text={row.value} question={row.value} answer={row.original.answer} />,
    },
    {
      accessor: 'answer',
      Header: '답변내용',
      className: 'align-left',
      resizable: true,
      width: 400,
      Cell: (row) => <OpenCsQnaQuestion text={row.value} question={row.original.question} answer={row.value} />,
    },
    {
      accessor: 'answerDate',
      Header: '답변 일자',
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
    {
      accessor: 'createDate',
      Header: '문의 작성 일자',
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};

export default columns;
